// Nastavitve kioska. Spreminjaj samo vrednosti na desni.
window.CONFIG = {
  // Ponudba »tehnični listi in vzorci materialov v 48 urah«: false, dokler JP ne potrdi.
  offer: false,
  offerText: "Tehnični listi in vzorci materialov v 48 urah.",

  // Mirovanje: po toliko sekundah brez dotika se aplikacija ponastavi in začne zanka.
  idleSeconds: 120,
  // Toliko sekund pred ponastavitvijo se pokaže vprašanje »Nadaljujete?« (0 = brez).
  idleWarnSeconds: 15,
  // Po potrditvi obrazca se zaslon sam vrne na začetek po toliko sekundah.
  thanksSeconds: 45,

  // Zanka med mirovanjem: "slides" (izdelki stojnice 2), "video" (TV zanka st. 7) ali oboje po vrsti.
  attract: ["slides", "video"],
  attractVideo: "video/zanka_st7.mp4",
  slideSeconds: 7,

  // Tajni dostop za prodajalca: trikrat tapni levi zgornji kot (znak hēka) v 2 s, nato PIN.
  adminPin: "0511",

  // Povečava strani konfiguratorja v okvirju (večje tarče za prst). 1 = brez.
  frameZoom: 1.45,

  // Zaslonska tipkovnica: true (priporočeno za kiosk), false (sistemska tipkovnica).
  keyboard: true,

  // Javni naslov trgovine (za povezave in QR).
  publicBase: "https://heka-interior.si",
  qrUtm: "utm_source=ambient26&utm_medium=kiosk&utm_campaign=ambient-2026",

  // Pošiljanje kontaktov v trgovino (Shopify kontaktni obrazec). Na kiosku IZKLOPLJENO: obrazec trgovine zahteva
  // CAPTCHA (preverjeno 1. 11.: »Missing CAPTCHA token«), zato kontakti ostanejo v kontakti/kontakti.csv in v brskalniku.
  // Na heka-interior.si (shopify/) se pošlje pravi obrazec trgovine, ki CAPTCHA reši sam.
  submit: {
    enabled: false,
    endpoint: "/contact",
    kanal: "Ambient 2026 - kiosk",
    oznaka: "ambient26",
    stojnica: "2",
    retrySeconds: 60,
  },

  // Ime naprave v zapisu (če je več zaslonov).
  device: "kiosk-75",
};
